export function mobileNav() {
    const body = $("body");
    const btnMenu = $(".btn-menu");
    const mainNav = $('.main-menu');
    const mainNavItems = mainNav.find('.menu-item-has-children');
    const arrowButton = `<button class="arrow-button">
                            <svg width="10" height="19" viewBox="0 0 10 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.5681 17.973C1.2789 18.2637 0.808515 18.2637 0.519314 17.973C0.232096 17.6844 0.232097 17.218 0.519314 16.9293L7.91258 9.5L0.519313 2.07065C0.232096 1.78203 0.232096 1.31557 0.519313 1.02695C0.808514 0.736341 1.2789 0.736341 1.5681 1.02695L10 9.5L1.5681 17.973Z" fill="#093048"/>
                            </svg>

                        </button>`;
    const backButton = `<div class="back-link">
						  <button>
						  <svg width="16" height="9" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.95745 9L0 4.48989L5.95745 0V4.04494H16V4.95506H5.95745V9Z" fill="#42529E"/>
                            </svg>

						    Back
						  </button>
					    </div>`;
    let activeMenuItem;

    //burger
    btnMenu.on("click", function (e) {
        let $this = $(this);
        if (!$this.hasClass("open")) {
            $this.addClass("open");
            body.addClass("menu-opened");
        } else {
            $this.removeClass("open");
            body.removeClass("menu-opened");
        }
        mainNav.find('> li').removeClass('active').show();
        mainNav.find('> .menu-item-has-children').removeClass('active');
        e.preventDefault();
    });

    //append arrow and back buttons
    mainNavItems.each((i, item) => {
        const menuList = $(item).find(' > .sub-menu');
        $(menuList).prepend(backButton);
        if (!$(item).find('.arrow').length) {
            $(arrowButton).insertBefore(menuList, null);
        }
    });

    //close menu
    function closeDropdown(e) {
        if (!mainNavItems.has(e.target).length > 0) {
            mainNavItems.removeClass('active');
            window.removeEventListener('click', closeDropdown);
        }
    }

    //show/hide menu
    $(document).on("click", mainNav, function (e) {
        const target = $(e.target);

        // if (target.closest('.menu-item-has-children > a').length) {
        //     e.preventDefault();
        // }

        if (target.closest('.menu-item-has-children .arrow-button').length) {
            activeMenuItem = target.closest('.menu-item-has-children');
            if (body.hasClass('touch') || window.innerWidth < 1200) {
                if (!activeMenuItem.hasClass("active")) {
                    activeMenuItem.siblings().removeClass('active');
                    activeMenuItem.addClass("active");
                    window.addEventListener('click', closeDropdown);
                } else {
                    activeMenuItem.removeClass("active");
                    window.removeEventListener('click', closeDropdown);
                }
            }
        }

        if (target.closest('.back-link button').length) {
            $('.menu-item-has-children').removeClass('active');
            activeMenuItem.removeClass("active");
            activeMenuItem = activeMenuItem.closest('.menu-item-has-children.active');
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/mobileNav.js